import { Location } from '@angular/common';
import { Component, Injectable, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HomeController } from '@shared/src/controllers/home/home.controller';
import { AmbitMaintenanceController } from '@shared/src/controllers/maintenance/ambit/AmbitMaintenanceController';
import { RouteController } from '@shared/src/controllers/route/route.controller';
import { SecurityController } from '@shared/src/controllers/security/security.controller';
import { SocketController } from '@shared/src/controllers/socket/socket.controller';
import { SharedAsideFactory } from '../../aside/shared.aside.factory';
import { SharedActiveRoutesSlotsAbstract } from '../activebase/shared.active.routesslots.abstract';
import { AddressAmbitSelectorDto } from '../../components.api';


@Component({
	selector: 'shared-active-routes',
	templateUrl: '../activebase/shared.active.routesslots.abstract.html',
	styleUrls: ['../activebase/shared.active.routesslots.abstract.scss']
})
@Injectable()
export class SharedActiveRoutes extends SharedActiveRoutesSlotsAbstract {

	constructor(public activatedRoute: ActivatedRoute,
		public router: Router, public location: Location, public routeController: RouteController,
		public ambitController: AmbitMaintenanceController,
		@Inject('HomeController') protected homeController: HomeController,
		@Inject("SecurityController") protected securityController: SecurityController,
		@Inject('SharedAsideFactory') public sharedAsideFactory: SharedAsideFactory,
		protected socketController: SocketController) {
		super(activatedRoute, router, location, routeController, ambitController, homeController, securityController, sharedAsideFactory, socketController);
		
	}

	ngOnInit(): void {
		if (this.useIonic)
			this.addressAmbit = AddressAmbitSelectorDto.buildActiveRoutesMobile();
		else
			this.addressAmbit = AddressAmbitSelectorDto.buildActiveRoutes();

		super.ngOnInit();
	}

}
